module.exports = __webpack_public_path__ + "static/media/womanClapping.f7189ca9.jpg";